import { Injectable, inject } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { ContactUsRequest } from "../general/models/contact-us-request.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EmailService {
    private http = inject(HttpClient);

    private apiUrl = environment.apiUrl;

    sendContactFormSubmission(request: ContactUsRequest): Observable<any> {
        return this.http.post(`${this.apiUrl}/send`, request);
    }
}